import { isNil } from 'lodash';

import { BackofficeUserModel } from 'api/backofficeApiClient';
import { UserRole } from 'enums';
import { AuthState } from '../redux/reducers/authenticationSlice';

const USER_ROLES = {
  [UserRole.Admin]: [UserRole.Admin],
  [UserRole.User]: [UserRole.User],
  [UserRole.RecruiterCompany]: [UserRole.RecruiterCompany],
  [UserRole.CorporateTA]: [UserRole.CorporateTA],
  [UserRole.TeammateAdmin]: [UserRole.TeammateAdmin],
  [UserRole.TeammateRecruiter]: [UserRole.TeammateRecruiter],
  [UserRole.TeammateSubAdmin]: [UserRole.TeammateSubAdmin],
  [UserRole.Teammates]: [
    UserRole.TeammateAdmin,
    UserRole.TeammateRecruiter,
    UserRole.TeammateSubAdmin,
  ],
  [UserRole.Users]: [
    UserRole.User,
    UserRole.CorporateTA,
    UserRole.RecruiterCompany,
  ],
  [UserRole.All]: [
    UserRole.Admin,
    UserRole.User,
    UserRole.CorporateTA,
    UserRole.RecruiterCompany,
  ],
};

export const getUserRoles = (...roles: UserRole[]) => {
  if (roles.includes(UserRole.All)) {
    return USER_ROLES[UserRole.All];
  }

  const userRoles = roles.reduce((acc: UserRole[], role) => {
    const roles = USER_ROLES[role];

    return [...acc, ...roles];
  }, []);

  return userRoles;
};

export const isAdminRole = (auth?: AuthState) => {
  const { user, activeRole } = auth || {};

  if (checkIsMultiAccount(user?.roles)) {
    return !isNil(activeRole) ? auth?.activeRole === UserRole.Admin : true;
  }

  return (user?.roles || []).some(
    (role) => getUserRoles(UserRole.Admin).indexOf(role as UserRole) >= 0,
  );
};

export const checkIsCompanyOwner = (user: BackofficeUserModel | null) =>
  user?.companyId === user?.userId;

export const checkIsMultiAccount = (roles?: string[]) =>
  roles?.includes(UserRole.Admin) && roles?.includes(UserRole.User);
